
import fetch from '../../fetch';


const transform = (data) => {
    return data.map((d) => {
        let current = {
            label: d.name,
            key: d.cid + '',
            value: d.cid + ''
        };

        if(d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const codes = (data) => {
    const maps = {};
    data.forEach(d => {
        maps[d.cid] = d.name;
    });

    return maps;
}

/**
 * @method queryNationalEconomy
 * @param {object} [keywords]
 * @return {promise}
 */
const queryNationalEconomy = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryNationalEconomy', keywords)
    .then(response => response.payload.data)
    .then(result => {
        const data = transform(tree(result));
        const maps = codes(result);
        return {
            data,
            maps
        }
    })
}

/**
 * @method querySocialEconomy
 * @param {object} [keywords]
 * @return {promise}
 */
 const querySocialEconomy = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/querySocialEconomy', keywords)
    .then(response => response.payload.data)
    .then(result => {
        const data = transform(tree(result));
        const maps = codes(result);
        return {
            data,
            maps
        }
    })
}

/**
 * @method queryNationalNature
 * @param {object} [keywords]
 * @return {promise}
 */
 const queryNationalNature = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryNationalNature', keywords)
    .then(response => response.payload.data)
    .then(result => {
        const data = transform(tree(result));
        const maps = codes(result);
        return {
            data,
            maps
        }
    })
}

const tree = (array) => {
    var treeData = [];
    var treeMaps = {};
    var treeSize = array.length;

    for (let i = 0; i < treeSize; i++) {
        treeMaps[array[i]["cid"]] = array[i];
    }
    for (let i = 0; i < treeSize; i++) {
        var node = treeMaps[array[i]["upCid"]];
        if (node) {
            if(node.hasOwnProperty('children') === false) {
                node["children"] = [];
            }
            node["children"].push(array[i]);
        } else {

                treeData.push(array[i]);
 
        }
    }
    sortTree(treeData);

    return treeData;
};

function sortTree(tree) {

    tree.sort(function(a ,b) {
        if(a.orderNum > b.orderNum) {
            return 1;
        } else if(a.orderNum < b.orderNum) {
            return -1;
        }
        return 0;
    });

    tree.forEach(d => {
        if(d.children) {
            sortTree(d.children);
        }
    });
}


const querySubject =  (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/querySubject', keywords)
    .then(response => response.payload.data)
}

const queryCheckLog =  (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryCheckLog', keywords)
    .then(response => response.payload.data)
}

const queryBuyerTypeList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryBuyerType', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

const queryPaperTypeList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryPaperType', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

const queryPaperLevelList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryPaperLevel', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

const queryEmployTypeList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryEmployType', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

const queryPublishRangeList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryPublishRange', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

const queryPageSpaceList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryPageSpace', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

const queryReshipTypeList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryReshipType', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

const queryBookTypeList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryBookType', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}


const queryReportTypeList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryReportType', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

const queryProductTypeList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryProductType', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

const queryArtFormList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryArtFrom', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

const queryCopyrightTypeList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryCopyrightType', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

const queryPatentTypeList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryPatentType', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

const queryHonorTypeList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryHonorType', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

const queryHonorLevelList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryHonorLevel', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

const queryHonorGradeList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryHonorGrade', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

const queryHonorClassList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryHonorClass', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

const queryProjectLevelList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/resources/queryProjectLevel', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}


export default {
    queryNationalEconomy,
	querySocialEconomy,
	queryNationalNature,
	querySubject,
    queryCheckLog,
    queryBuyerTypeList,
    queryPaperTypeList,
    queryPaperLevelList,
    queryEmployTypeList,
    queryPublishRangeList,
    queryPageSpaceList,
    queryReshipTypeList,
    queryBookTypeList,
    queryReportTypeList,
    queryProductTypeList,
    queryArtFormList,
    queryCopyrightTypeList,
    queryPatentTypeList,
    queryHonorTypeList,
    queryHonorLevelList,
    queryHonorGradeList,
    queryHonorClassList,
    queryProjectLevelList
}